import { withRouter } from 'react-router'

import { compose, withProps } from 'recompose'

import { isMobile } from 'components/Trackers/platform'
import { withFlowRouter } from 'utils/FlowProvider'

import { AddedProps, EnhancedMiniNavProps, InnerProps, MiniNavProps } from './types'

export const enhance = compose<EnhancedMiniNavProps, MiniNavProps>(
  withRouter,
  withFlowRouter,
  withProps<InnerProps, MiniNavProps & AddedProps>(
    ({ flowProgress, match, partnerLogo, referralAmount, hideNavOnMobileLandscape }) => {
      const hideNav =
        isMobile() && hideNavOnMobileLandscape && window.innerWidth > window.innerHeight

      const { stepOverallProgress: value } = flowProgress(match.path)

      return {
        hasBanner: partnerLogo || referralAmount ? true : false,
        value,
        hideNav,
      }
    },
  ),
)
